import React from "react";
import Header from "./Header";
import Footer from "./Footer"
import pdf from "../konkurs.pdf"
import pdf2 from "../Prijava.pdf"

const Konkurs = () => {

    return(
        <div>
            <Header />
            <div style={{textAlign:'center'}}>
                <h2>Dokument konkursa možete pogledati: <i><a style={{color:'#3b3b3b'}} target={'_blank'} href={pdf}>ovdje</a></i></h2>
                <h2>Prijavu za upis polaznika možete pogledati: <i><a style={{color:'#3b3b3b'}} target={'_blank'} href={pdf2}>ovdje</a></i></h2>
            </div>
            <Footer />
        </div>
    );

}

export default Konkurs;